jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMenu();
	setupSearch();
	setupColumns();
	setupScrollEvents();
	setupAutoModal();
	setupFancyFocus();
	
}

function setupMenu(){
	
	jQuery('.menu-button, #site-menu').on('click', function(){
		
		jQuery('html').addClass('menu-open');
		
		sessionStorage.setItem('skipModal', true);
		
		var modalContainer = jQuery('#auto-modal');
		var modal = modalContainer.remodal();
	
		modal.close();
		
	});
	
	jQuery('#menu-flyout a.close').on('click', function(){
		jQuery('html').removeClass('menu-open');
	});
	
	jQuery('#menu-flyout-nav li.menu-item-has-children > a').append('<span class="toggle">Toggle</span>');
	
	jQuery('#menu-flyout-nav li.menu-item-has-children span.toggle').on('click', function(){
		
		var current = jQuery(this).parent().parent();
		
		if(current.hasClass('active')) {
			
			current.removeClass('active');
			current.siblings('li').removeClass('inactive');
			
		} else {
			
			current.addClass('active');
			current.siblings('li').addClass('inactive');
			
		}
		
		jQuery('ul.sub-menu', current).slideToggle(300);

	});
	
}

function setupSearch() {

	jQuery('a.search-toggle').on('click', function(){
		jQuery('html').addClass('search-open');
		jQuery('#global-search').focus();
	});
	
	jQuery('#search-container').on('click', function(e){
		e.stopPropagation();
	});
	
	jQuery('html').on('click', function(){
		jQuery(this).removeClass('search-open');
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupScrollEvents() {
	
	jQuery(window).on('scroll', checkTop);
	
	checkTop();
	
}

function checkTop() {
	
	var offset = jQuery(window).scrollTop();
	var html = jQuery('html');
	
	if(offset > 100) {
		html.addClass('not-top');
	} else {
		html.removeClass('not-top');
	}
	
}

function setupAutoModal() {
	
	var modalTiming = 20000;
	var modalContainer = jQuery('#auto-modal');
	var skipModal = sessionStorage.getItem('skipModal');
	
	if(skipModal) {
		return false;
	}
	
	setTimeout(function(){
		
		skipModal = sessionStorage.getItem('skipModal');
		
		if(skipModal) {
			return false;
		}
		
		var modal = modalContainer.remodal();
	
		modal.open();
		
		sessionStorage.setItem('skipModal', true);
		
	}, modalTiming);
	
}

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest(".gfield").addClass('focus');
		jQuery(this).closest(".js-cm-form").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest(".gfield").removeClass('focus');
			listItem.closest(".js-cm-form").removeClass('focus');
		}
		
	});
}

